/* global globalThis */
export const RUNTIME_VERSION = 'northstar-browser/0.3.0-test.1';
export const DEFINITION_ID = 'northstar-calibration';
export const DEFINITION_VERSION = '0.3.0-test.1';

export function canonical(value) {
  if (Array.isArray(value)) return `[${value.map(canonical).join(',')}]`;
  if (value && typeof value === 'object') return `{${Object.keys(value).sort().map(key => `${JSON.stringify(key)}:${canonical(value[key])}`).join(',')}}`;
  if (typeof value === 'number' && !Number.isFinite(value)) throw new Error('Nonfinite values cannot identify a calibration.');
  return JSON.stringify(value);
}

export async function sha256(bytes) {
  if (!globalThis.crypto?.subtle) throw new Error('A secure browser with SHA-256 support is required.');
  const digest = await globalThis.crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest), value => value.toString(16).padStart(2, '0')).join('');
}

export const hashObject = value => sha256(new TextEncoder().encode(canonical(value)));
